/* eslint-disable @nx/enforce-module-boundaries */
'use client';

import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { isMobile } from 'react-device-detect';
import { Card, Container, Flex, Stack, Text, HStack, Box } from '@mybridge/ui';
import Sidebar from 'v4/components/search/Sidebar';
import Account from '../Account/Account';
import Notifications from '../Notifications/Notifications';
import Pages from '../Pages';
import Payment from '../Payment';
import Team from '../Team';
import DiskSubscription from '../DiskSubscription/DiskSubscription';
import Integration from '../Integration/Integration';
import VisibilityAudience from '../Visibility/VisibilityAudience';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
import { BackButton } from '@mybridge/icons';

import FindPeopleAndContact from '../FindPeopleAndContact/FindPeopleAndContact';
import MentionAndTag from '../MentionAndTag/MentionAndTag';
import SubscriptionsAndPayment from '../SubscriptionAndPayment';
import Subscription from '../SubscriptionAndPayment/Subscription';
import BillingInfo from '../SubscriptionAndPayment/BillingInfo';
import BillingHistory from '../SubscriptionAndPayment/BillingHistory';
import IntegrationForMobile from '../IntegrationForMobile';
import CreatePage from '../Pages/createPage';
import HelpAndSupport from '../HelpAndSupport';
import PrivacyAndTerm from '../PrivacyAndTerm';
// import PrivacyPage from '../PrivacyAndTerm/privacyPage';
import PrivacyPage from '../PrivacyAndTerm/PrivacyPage'
import AboutUs from '../PrivacyAndTerm/aboutPage';
import TermsAndCondition from '../PrivacyAndTerm/TermsAndCondition';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

import {trackEvent, ANALYTICS_EVENTS } from 'v4/utils/analyticsEvents.js';
import { useSelector } from 'react-redux';


const SettingsPage = () => {
  const router = useRouter();
  const [selectedComponent, setSelectedComponent] = useState('');
  const [selectedAccountComponent, setSelectedAccountComponent] = useState('');
  const slug = router?.query?.slug?.toString();
  const [selectedSubItem, setSelectedSubItem] = useState('calendar-sync');
  const [sidebarVisible, setSidebarVisible] = useState(true);
  const [isEditing, setIsEditing] = useState('');
  const [editMode, setEditMode] = useState(false);
  const [isChangeNumber, setIsChangeNumber] = useState(false);
  const [addEditEmailOtp, setAddEditEmailOtp] = useState(false);
  const [addEditEmail, setAddEditEmail] = useState(false);
  const [mobileOtp, setMobileOtp] = useState(false);
  const { t } = useTranslator();
  const handleComponentSelection = (component) => {
    setSidebarVisible(false); // Hide the sidebar when a component is selected
    setSelectedComponent(component); // Update the selected component
  };

const { userProfileInfo } = useSelector((state) => state.userProfile);

const trackSettingsPageVisit = () => {
  const userSlug = userProfileInfo?.slug;
  if (!userSlug) return;

  trackEvent(ANALYTICS_EVENTS.Settings, userSlug, {
    page_path: router.asPath,
    page_title: 'Settings',
    device_type: isMobile ? 'mobile' : 'desktop',
    timestamp: new Date().toISOString()
  });
};

useEffect(() => {
  trackSettingsPageVisit();
}, []);

  useEffect(() => {
    if (
      router?.query?.slug?.includes('zoom') ||
      router?.query?.slug?.includes('teams') ||
      router?.query?.slug?.includes('webex') ||
      router?.query?.slug?.includes('gotomymeeting')
    ) {
      if (slug?.includes('conferencing')) {
        // setSelectedComponent('video-conferencing');
        setSelectedSubItem('video-conferencing');
      } else {
        setSelectedComponent('calendar-sync');
      }
    } else {
      setSelectedComponent(slug);
    }
  }, [slug]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  }, [selectedComponent, slug]);
  
  const setTabsIndex = (e) => {
    setSelectedComponent(e);
    router.push(`${e}`);
  };
  const renderHeading = () => {
    const componentNames = {
      account: 'Account',
      notifications: 'Notifications',
      pages: 'Pages',
      'billing-and-payment': 'Subscription & Payments',
      permissions: 'Permissions',
      subscriptions: 'Subscriptions',
      'calendar-sync': 'Calendar Sync',
      'google':'Google Calender',
      'iCloud': 'iCloud Calendar',
      'microsoft': 'Outlook Calendar',
      'exchange': 'Exchange Calendar',
      'Google meet': 'Google meet',
      'zoom': 'Zoom Meet',
      'Microsoft teams conferencing':'Microsoft Meet',
      'GoTo Meeting Information': 'GoTo Meet',
      'Webex Information': 'Webex Meet',
      'video-conferencing': 'Video Conferencing',
      'app-extenstions': 'Apps & Extensions',
      'create-new-page': 'Create New Page',
      'audience-and-visibility': 'Audience and Visibility',
      'how-people-find-and-contact-you': 'How people find and contact you',
      'mention-and-tag': 'Mention or Tags',
      support: 'Help and support',
      subscription: 'Subscriptions',
      'billing-info': 'Billing info',
      'billing-history': 'Billing history',
      'account-security': 'Account and security',
      'subscription-billing-paypment': 'Subscription, Billing & Payment',
      'privacy-policy': 'Privacy and Terms',
      'privacy-policy-term': 'Privacy Policy',
      'privacy-policy-about': 'About Us',
      'privacy-policy-term-condition': 'Term and Conditions',
      integration: 'Integration',
      name: 'Edit Account Information',
      password: 'Change Password ',
      language: 'Language',
      email: 'Email address',
      phone: 'Edit Phone Number',
      otp: 'Enter OTP',
      location: 'Edit address',
    };
    return componentNames[selectedComponent] || 'Settings'; // Default to 'Settings' if no match
  };
  const renderAccountHeading = () => {
    const componentNames = {
      name: 'Edit Account Information',
      password: 'Change Password ',
      language: 'Language',
      email: 'Email address',
      phone: 'Edit Phone Number',
      otp: 'Enter OTP',
      location: 'Edit address',
    };

    return componentNames[selectedAccountComponent] || 'Account'; // Default to 'Settings' if no match
  };
  
  useEffect(() => {
    const slug = router?.query?.slug?.toString();
    const isSettingsPages = slug === 'pages' || selectedComponent === 'pages';

    if (isSettingsPages) {
      // Add CSS class to body
      document.body.classList.add('settings-pages-body');
    } else {
      // Remove CSS class from body
      document.body.classList.remove('settings-pages-body');
    }

    // Cleanup function
    return () => {
      document.body.classList.remove('settings-pages-body');
    };
    // }, [router?.query?.slug, selectedComponent]);
  }, [slug, selectedComponent]);

  return (
    <AuthenticatedProviders>
      <Container maxW="1360px" w="100%" py={3}>
        <Card variant="thinBorderedCard" minH="calc(100vh - 90px)">
          {isMobile ? (
            <>
              <HStack
                w="100%"
                padding="10px 15px"
                align="center"
                justifyContent="space-between" // Distribute space between BackButton and Heading
              >
                {/* Back Button */}
                <BackButton
                  onClick={() => {
                    if (renderHeading() === 'Settings') {
                      router.push('/');
                      setSelectedAccountComponent(''); // Clear the subcomponent state
                      setSelectedComponent(''); // Clear the main component state
                    } else if (
                      selectedComponent === 'how-people-find-and-contact-you' ||
                      selectedComponent === 'mention-and-tag'
                    ) {
                      setSelectedComponent('audience-and-visibility'); // Clear the main component state
                    } else if (
                      selectedComponent === 'calendar-sync' ||
                      selectedComponent === 'video-conferencing' ||
                      selectedComponent === 'app-extenstions'|| [
                        'google',
                        'microsoft',
                        'iCloud',
                        'exchange',
                        'Google meet',
                        'zoom',
                        'Microsoft teams conferencing',
                        'GoTo Meeting Information',
                        'Webex Information'
                      ].includes(selectedComponent)
                    ) {
                      setSelectedComponent('integration'); // Clear the main component state
                    } else if (
                      selectedComponent === 'privacy-policy-term' ||
                      selectedComponent === 'privacy-policy-term-condition' ||
                      selectedComponent === 'privacy-policy-about'
                    ) {
                      setSelectedComponent('privacy-policy'); // Clear the main component state
                    } else if (
                      selectedComponent === 'subscription' ||
                      selectedComponent === 'billing-info' ||
                      selectedComponent === 'billing-history'
                    ) {
                      setSelectedComponent('billing-and-payment'); // Clear the main component state
                    } else if (
                      selectedComponent === 'account-security' ||
                      selectedComponent === 'subscription-billing-paypment'
                    ) {
                      setSelectedComponent('support'); // Clear the main component state
                    } else if (selectedComponent === 'create-new-page') {
                      setSelectedComponent('pages');
                    } else if (selectedAccountComponent) {
                      setIsEditing('');
                      setEditMode(false);
                      setSelectedAccountComponent('');
                      setAddEditEmail(false);
                      setAddEditEmailOtp(false);
                      setIsChangeNumber(false);
                      setMobileOtp(false);
                    } else {
                      setSelectedAccountComponent(''); // Clear the subcomponent state
                      setSelectedComponent(''); // Clear the main component state
                      setSidebarVisible(true); // Show the sidebar
                    }
                  }}
                />

                {/* Centered Heading */}
                <Text
                  as="h4"
                  size="lg"
                  pb={[0, '10px']}
                  textAlign="center"
                  borderBottom={['0', '1px']}
                  borderColor="brandPrimary.900"
                  color="#4F4F4F"
                  fontWeight="400"
                  whiteSpace="nowrap" // Prevent text from wrapping
                  overflow="hidden" // Hide overflowing text
                  textOverflow="ellipsis" // Show ellipsis for truncated text
                  flex="1" // This ensures that the heading takes up remaining space and remains centered
                  sx={{
                    '@media screen and (max-width: 375px)': {
                      fontSize: '14px',
                    },
                    '@media screen and (max-width: 280px)': {
                      fontSize: '12px',
                      marginLeft: '5px',
                    },
                    marginRight: '10%', // Added margin-right of 10%
                  }}
                >
                  {selectedAccountComponent
                    ? renderAccountHeading()
                    : renderHeading()}
                </Text>
              </HStack>

              {sidebarVisible &&
                ![
                  'account',
                  'notifications',
                  'pages',
                  'billing-and-payment',
                  'permissions',
                  'subscriptions',
                  'integration',
                  'calendar-sync',
                  'video-conferencing',
                  'audience-and-visibility',
                  'support',
                  'privacy-policy',
                  'create-new-page',
                ].includes(selectedComponent) && (
                  <Sidebar
                    selectedComponent={selectedComponent}
                    setSelectedComponent={handleComponentSelection}
                    settingsPage={true}
                    setSelectedSubItem={setSelectedSubItem}
                    selectedSubItem={selectedSubItem}
                  />
                )}

              {/* Render the selected component */}
              {(selectedComponent === 'account' ||
                [
                  'name',
                  'password',
                  'language',
                  'email',
                  'phone',
                  'otp',
                  'location',
                ].includes(selectedAccountComponent)) && (
                <Account
                  setIsEditing={setIsEditing}
                  isEditing={isEditing}
                  setEditMode={setEditMode}
                  editMode={editMode}
                  setAddEditEmail={setAddEditEmail}
                  addEditEmail={addEditEmail}
                  setAddEditEmailOtp={setAddEditEmailOtp}
                  addEditEmailOtp={addEditEmailOtp}
                  setSelectedComponent={setSelectedComponent}
                  setSelectedAccountComponent={setSelectedAccountComponent}
                  setIsChangeNumber={setIsChangeNumber}
                  isChangeNumber={isChangeNumber}
                  setMobileOtp={setMobileOtp}
                  mobileOtp={mobileOtp}
                />
              )}

              {selectedComponent === 'notifications' && (
                <Notifications setSelectedComponent={setSelectedComponent} />
              )}
              {selectedComponent === 'pages' && (
                <Pages setSelectedComponent={setSelectedComponent} />
              )}
              {selectedComponent === 'billing-and-payment' && (
                <SubscriptionsAndPayment
                  setSelectedComponent={handleComponentSelection}
                />
                // <Payment setSelectedComponent={setSelectedComponent} />
              )}
              {selectedComponent === 'support' && (
                <HelpAndSupport
                  setSelectedComponent={handleComponentSelection}
                />
                // <Payment setSelectedComponent={setSelectedComponent} />
              )}
              {selectedComponent === 'privacy-policy' && (
                <PrivacyAndTerm
                  setSelectedComponent={handleComponentSelection}
                />
                // <Payment setSelectedComponent={setSelectedComponent} />
              )}
              {/* {selectedComponent === 'permissions' && (
                <Team setSelectedComponent={setSelectedComponent} />
              )} */}
              {selectedComponent === 'subscriptions' && (
                <DiskSubscription setSelectedComponent={setSelectedComponent} fromSettings={true} />
              )}
              {selectedComponent === 'calendar-sync' && (
                <Integration
                  selectedSubItem={selectedSubItem}
                  setSelectedComponent={handleComponentSelection}
                />
              )}
              {selectedComponent === 'video-conferencing' && (
                <Integration setSelectedComponent={handleComponentSelection} selectedSubItem={selectedSubItem} />
              )}
              {selectedComponent === 'audience-and-visibility' && (
                <VisibilityAudience
                  selectedComponent={selectedComponent}
                  setSelectedComponent={handleComponentSelection}
                />
              )}
              {selectedComponent === 'how-people-find-and-contact-you' && (
                <FindPeopleAndContact />
              )}
              {selectedComponent === 'privacy-policy-term' && <PrivacyPage />}
              {selectedComponent === 'privacy-policy-about' && <AboutUs />}
              {selectedComponent === 'privacy-policy-term-condition' && (
                <TermsAndCondition />
              )}

              {selectedComponent === 'mention-and-tag' && <MentionAndTag />}
              {[
                'subscription',
                'account-security',
                'subscription-billing-paypment',
                'google',
                'microsoft',
                'iCloud',
                'exchange',
                'Google meet',
                'zoom',
                'Microsoft teams conferencing',
                'GoTo Meeting Information',
                'Webex Information'
    
              ].includes(selectedComponent) && <Subscription />}

              {selectedComponent === 'integration' && (
                <IntegrationForMobile
                  setSelectedSubItem={setSelectedSubItem}
                  setSelectedComponent={handleComponentSelection}
                />
              )}
              {selectedComponent === 'billing-info' && <BillingInfo />}
              {(selectedComponent === 'create-new-page' ||
                selectedComponent === 'permissions') && (
                <CreatePage text={''} />
              )}
              {selectedComponent === 'app-extenstions' && (
                <BillingInfo text={t('pages.featureOptimizedForDesktop') || "This Feature is optimized for our desktop site."} />
              )}
              {selectedComponent === 'billing-history' && <BillingHistory />}
            </>
          ) : (
            <Flex minH={"100vh"}>
              <Sidebar
                selectedComponent={selectedComponent}
                setSelectedComponent={setSelectedComponent}
                settingsPage={true}
                setSelectedSubItem={setSelectedSubItem}
                selectedSubItem={selectedSubItem}
              />

              <Stack flex={1} p="20px" minW={0} maxW="100%">
                {/* Render the selected component */}
                {selectedComponent === 'account' && (
                  <Account
                    setIsEditing={setIsEditing}
                    isEditing={isEditing}
                    setEditMode={setEditMode}
                    editMode={editMode}
                    setAddEditEmail={setAddEditEmail}
                    addEditEmail={addEditEmail}
                    setAddEditEmailOtp={setAddEditEmailOtp}
                    addEditEmailOtp={addEditEmailOtp}
                    setSelectedComponent={setSelectedComponent}
                    setSelectedAccountComponent={setSelectedAccountComponent}
                    setIsChangeNumber={setIsChangeNumber}
                    isChangeNumber={isChangeNumber}
                    setMobileOtp={setMobileOtp}
                    mobileOtp={mobileOtp}
                  />
                )}
                {selectedComponent === 'notifications' && <Notifications />}
                {selectedComponent === 'pages' && <Pages />}
                {selectedComponent === 'billing-and-payment' && <Payment />}
                {selectedComponent === 'permissions' && <Team />}
                {selectedComponent === 'subscriptions' && (
                  <DiskSubscription
                    fromSettings={true}
                    setSelectedComponent={setSelectedComponent}
                  />
                )}
                {selectedComponent?.includes('integration') && (
                  <Integration selectedSubItem={selectedSubItem} />
                )}
                {selectedComponent === 'calendar-sync' && (
                  <Integration selectedSubItem={selectedSubItem} />
                )}
                {selectedComponent === 'audience-and-visibility' && (
                  <VisibilityAudience />
                )}
              </Stack>
            </Flex>
          )}
        </Card>
      </Container>
    </AuthenticatedProviders>
  );
};

export default SettingsPage;
